const Metric        = require('./class/Metrics');
const EventManager  = require('./class/EventManager');
const AjaxPull      = require('./class/AjaxPull');
const Goals        = require('./class/Goals');
const Debug        = require('./class/Debug');
const Axios         = require('axios');
const DmpProf         = require('./class/DmpProf');
const Queue         = require('./class/Queue');
const Ajax         = require('./class/Ajax');

//=======================================
const urlGetArticle     = "/api/get-n-item";
const urlGetArticles    = "/api/get-n-items";
const urlGetArticlesForForWhiteShowcase    = "/api/get-wn-items";
const urlGetAds         = "/api/get-items";
const urlSetView        = "/api/set-view";
const urlGoals          = "/api/goals";
const urlGetUid         = "/get-uid";
const urlNextNews       = "/api/next-article";

const PROJECT_VITRINA = 1;
const PROJECT_GOOGLE_NEWS = 2;

const DMPPROF_ID = 1;
//=======================================
console.log("dmp2 v1.18");
window.pinter = 0;

// window.addEventListener('DOMContentLoaded', function() {
//     console.log('scroll top');
//     window.scrollTo(0,0);
// });

window.offsetForTest = 0;

//=======================================
module.exports = {
    beforeEventPreviewToView : [],

    host     : "",
    query    : {},
    uid:'',
    instance : undefined,
    languageDefault: 'ru',
    language: '',
    translate:{},
    pixelUrl: '',
    pixelDomain: '',
    events:{},
    audiences:{},
    city:'',
    isPreviewRef:false,
    notClear:false,
    metric:undefined,
    isTeaserViewFixAjax:false, //отправлять ajax для логирования просмотров тизеров
    isEnableDmpProfitclicks:false,
    sid9:'',
    is_visitor:false,
    is_send_visitor:false,
    config:{},
    dmp_created_at:null,
    dmpScript:null,
    vue:undefined,
    theme:'',
    pixelLoad:false,
    target:undefined,
    project: PROJECT_VITRINA,
    newsElementId: 'news',
    // isReadNews: false,
    isToBack: false,
    nextRnd: [],
    nextCout: 0,
    templateShowIdForView:null, //шаблон выдачи для вью
    teasersLIst:{},
    isDmp:true,
    isWap:true,
    isLoadDmp:false,
    wapRedirect:'',
    timeoutLoadDmp:1000,
    isVideo:false,

    //====================================
    init: function(config) {

        console.log(location.href);
        console.log("1.9");

        this.theme = config.config.theme || '';
        this.city  = config.config.city;
        this.isTeaserViewFixAjax  = config.isTeaserViewFixAjax || false;
        this.timeoutLoadDmp  = config.timeoutLoadDmp || 1000;
        this.isVideo  = config.isVideo || false;
        this.host  = config.host;
        this.query = config.query ? Object.assign(this.getQuery(), config.query) : {};
        if (!!config.sourceDefault && !!!this.query.utm_campaign) {
            this.query.utm_campaign = config.sourceDefault
        }

        this.pixelUrl = config.config.pixel_path;
        this.dmpAttributeTaxonomy = config.config.DmpLib || null;
        this.isEnableDmpProfitclicks = config.isEnableDmpProfitclicks || false;
        this.events   = new EventManager();
        this.debug = new Debug(this);
        this.wapRedirect = config.config.wap_redirect || '';
        this.project = config.config.project_id || PROJECT_VITRINA;

        this.isWap = (config.isWap === undefined || config.isWap === null) ? true : config.isWap;

        this.isDmp = (config.isDmp === undefined || config.isDmp === null) ? true : config.isDmp;


        if (config.config.check === undefined || config.config.check === null) {
            this.isDmp = false;
        } else {
            this.dmpScript = config.config.check;
        }

        let browserLanguage = this.getBrowserLanguage();
        let ajaxQuery = Object.assign({}, this.query);
        if (!!browserLanguage) {
            ajaxQuery.blang = browserLanguage;
        }


        this.ajaxPull = new AjaxPull(this.host,  ajaxQuery);
        this.ajaxPost = new AjaxPull(this.host);
        this.pixelDomain = '';

        if (config.config.pixel_path !== "") {
            this.pixelDomain = 'https://' + ((config.config.pixel_path.indexOf('//') === 0)
                ? new URL('https:' + config.config.pixel_path).hostname
                : new URL(config.config.pixel_path).hostname);
        }

        this.timeout = 30000;
        this.goals = new Goals(this, {host: this.host, url: urlGoals});

        this.goals.listener(this.events);

        // let a = Metric;
        if (this.isTeaserViewFixAjax) {
            config.metric      = config.metric || {};
            config.metric.url  = urlSetView;
            config.metric.host = this.host;

            this.metric = new Metric(this, config.metric,  this.ajaxPull);
        }
        // console.log('this.uid',this.uid);
        //debugger

        // if (!browserLanguage) {
        //     this.setLanguage(config.language, this.languageDefault);
        // } else {
        //     this.setLanguage(browserLanguage, config.language);
        // }

        this.setLanguage(config.language, this.languageDefault);

        //this.OneDmcIo = new OneDmcIo(this);
        //this.DmpProf = new DmpProf(this);

    },



    //------------------------------------------------
    // Получение новостей
    getArticles(rubricId, query, count, offset) {
        try {

            return this._getArticles(rubricId, query, count, offset);

        } catch (e) {
            return _fail("getArticles", e);
        }
    },
    //тут работают две рубрике 1 и 2
    getArticlesForForWhiteShowcase(rubricId, query, count, offset) {
        try {

            return this._getArticlesForForWhiteShowcase(rubricId, query, count, offset);

        } catch (e) {
            return _fail("getArticles", e);
        }
    },
    _getArticlesForForWhiteShowcase(rubricId, query, count, offset) {
        window.pinter = 0;
        query = Object.assign({}, query);

        query.offset = offset || 0;
        query.project = this.project;
        query.uri    = urlGetArticlesForForWhiteShowcase;
        query.rubric = rubricId;
        query.count  = count;

        return this.ajaxPull.get(query);
    },

    _getArticles(rubricId, query, count, offset) {
            window.pinter = 0;
            query = Object.assign({}, query);

            query.offset = offset || 0;
            query.project = this.project;
            query.uri    = urlGetArticles;
            query.rubric = rubricId;
            query.count  = count;

            return this.ajaxPull.get(query);
    },
    // Получение новости
    getArticle(hash, query) {
        try {

            return this._getArticle(hash, query) ;
        } catch (e) {
            return this._fail('getArticle', e);
        }
    },
    _getArticle(hash, query) {
            query = Object.assign({}, query);

            query.uri = urlGetArticle;
            query.hash = hash;
            query.project = this.project;
            let news = this.ajaxPull.get(query);


            news.onBeforeSuccess((response) => {

                if (response.data.id === 0) {
                    let img = window.vueApp.StatisPath + '/img/404.jpg';
                    console.log('_getArticle img', img);
                    response.data.image_square = img;
                    response.data.image_rectangle = img;
                } else {
                    // window.sessionStorage.setItem('content', response.data.hash_id);
                    this.setStorage('content', response.data.hash_id);
                    if (this.sid9 === "view") {
                        const utm_campaign = query.utm_campaign;

                        function replaceSourceIdMacros(inputString, replacementValue) {
                          const regex = new RegExp('{SOURCE_ID}', 'g');
                          const outputString = inputString.replace(regex, replacementValue);
                          
                          return outputString;
                        }

                        response.data.text = replaceSourceIdMacros(response.data.text, utm_campaign);

                        function replaceUtmContentForLinks() {
                          const regex = /href *= *"@([^=]+)=([^\"]+)"/g;

                          function replaceUtmContent(match, key, value) {
                            if (key === 'article_hash') {
                                const replacedUrl = window.location.href.replace(/utm_content=[^&]*/, 'utm_content=' + value);

                                return 'href="' + replacedUrl + '"';
                            }

                            return match;
                          }

                          return response.data.text.replace(regex, replaceUtmContent);
                        }

                        response.data.text = replaceUtmContentForLinks();

                        response.data.text += '<div id="scripts"></div><div id="scripts-news"></div>';
                    }
                }


            });

            news.onAfterSuccess((response) => {

                let isRead = false;
                setTimeout(() => {
                    this.events.notify('EVENT_LOAD_NEWS', response.data);

                    if (this.sid9 === "view") {

                        let scroll = (e) => {
                            // console.log('scroll');
                            if (this.isReadNews()) {
                                let percent = this.getPercentReadNews();
                                this.events.notify('EVENT_READ_NEWS', {news: response.data, percent: percent});
                            }
                        };

                        if (this.isReadNews()) {
                            scroll();
                        }

                        window.addEventListener('scroll', scroll);

                        // let scripts = document.getElementById('scripts');
                        // let scriptsNews = document.getElementById('scripts-news');
                        // if (scripts) {
                        //
                        //     scripts.innerHTML = response.data.script;
                        //
                        //     let scriptsEl = scripts.getElementsByTagName("script");
                        //     for (let i = 0; i < scriptsEl.length; i++) {
                        //
                        //         if (scriptsEl[i].innerText) {
                        //             eval(scriptsEl[i].innerText);
                        //         } else if (scriptsEl[i].src !== "") {
                        //             let newScript = document.createElement("script");
                        //             newScript.src = scriptsEl[i].src;
                        //             scriptsNews.appendChild(newScript);
                        //         }
                        //     }
                        //
                        //     scripts.innerHTML = scripts.innerHTML.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
                        //     ;
                        //
                        //
                        // }


                    }
                }, 300);
            });

            return news;
    },

    getTeasers(vue, count, offset, isBoost, isNotClear, appendQuery, maxSkipLastTeaser, isAddMissing, isVideo) {
        try {
            if(window.config.is_moderated === 1) {
                return this._getTeasers(vue, count, offset, isBoost, isNotClear, appendQuery, maxSkipLastTeaser, isAddMissing, isVideo);
            } else {
                return this.getArticlesForForWhiteShowcase(1, appendQuery, count, offset)
                //  return this.getEmptyTeasers();
            }
        } catch (e){
            return this._fail("getTeasers", e)
        }
    },

     // Получение белых тизеров если новость не прошла модерацию
    // getWhiteTeasers(appendQuery) {
    //     window.pinter = 0;

    //     appendQuery = appendQuery || {};
    //     let query = Object.assign({}, vue.$route.query, appendQuery);
    //     query.project = this.project;
    //     query.uri    = urlGetArticlesForForWhiteShowcase;
    //     query.rubric = 2;
    //     query.count  = 47;

    //     return this.ajaxPull.get(query);
    // },

    

     // Получение тизеров с рыбой если новость не прошла модерацию
    // getEmptyTeasers() {
    //     let ajax = new Ajax(config);

    //     setTimeout(() => {
    //         let teasersData = [];
    //         let count = 9;
    //         let img = window.vueApp.StatisPath + 'img/image-mob.png';
    //         console.log(img);
    //         console.log(window.vueApp.StatisPath);
    //         for(let i = 1; i <= count; i++) {
    //             teasersData.push({
    //                 "index": i,
    //                 "templates_show_id": null,
    //                 "teaser_id": null,
    //                 "position": 0,
    //                 "is_rtb": null,
    //                 "title": "",
    //                 "description": "",
    //                 "button_text": "",
    //                 "path_square_image": img,
    //                 "path_rectangle_image": img,
    //                 "click": "",
    //                 "data": "",
    //                 "rtb_user_id": "",
    //                 "rtb_request_id": "",
    //                 "rtb_imp_id": "",
    //                 "debug_weight": null,
    //                 "debug_factor": null,
    //                 "debug_info": "",
    //                 "debug": null,
    //                 "debug_data": "",
    //             })
    //         }
    //         ajax.call('onSuccess', {data: teasersData});
    //     }, 100)

    //     return ajax;

    // },

    // Получение тизеров
    _getTeasers(vue, count, offset, isBoost, isNotClear, appendQuery, maxSkipLastTeaser, isAddMissing, isVideo = true) {
            isAddMissing = isAddMissing || true;
            if (this.query.newback && this.query.type == 'back') {
                return this.getTeasers2(vue, count, offset, isBoost, isNotClear, appendQuery)
            }

            appendQuery = appendQuery || {};
            console.log("appendQuery", appendQuery);
            let query = Object.assign({}, vue.$route.query, appendQuery);      
            isBoost = isBoost || 0;
            isNotClear = isNotClear || 0;
            query.boost = isBoost;

            if (query.type && query.type === "back") {
                query.event = 'back';
            }

            query.dmp = this.getDMPValues(DMPPROF_ID);
            if (!appendQuery.sid9) query.sid9 = this.sid9;
            query.uid = this.uid;

            if (!query.utm_content && this.getStorage('content') !== null) {
                query.utm_content = this.getStorage('content');
            }
            console.log("isClear", this.isClear(query));
            console.log("isClearForTest", this.isClearForTest(query));
            if (!isNotClear && this.isClear(query)) {
                query.is_clear = 1;
                this._setCookie("not_clear", "1", {expires: new Date(Date.now() + 86400 * 1000)});


                this.notClear = true;
                this.isPreviewRef = false;
            } else if (this.isClearForTest()) {
                this.setStorage('isPreviewRefForTest', null);
                query.is_clear = 1;
            } else {
                query.is_clear = 0;
            }

            query.uri = urlGetAds;
            window.pinter = 0;
            //убрать!! "- 1"
            query.count = count;
            query.offset = offset;
            query.r = Math.random();

            query.theme = this.theme || "";


            console.log('isVideo',isVideo);
            let isv = false;
            if (isVideo === false) {
                isv = false;
            } else if (this.isVideo) {
                const isIOS = /(iPad|iPhone|iPod|MacIntel)/.test(navigator.userAgent) && !window.MSStream;
                console.log('isIOS', isIOS);
                if (isIOS) {
                  isv = false;
                } else {
                  isv = true;
                }
            }
            query.is_video = (isv) ? 1 : 0;
            console.log('query.is_video', query.is_video);

            query.resolution_width = screen.width;
            query.resolution_height = screen.height;
            query.connection_speed = this.connectionSpeed();
            delete query.uid;

            if (query.utm_content) {
                query.article = query.utm_content;
            }

            maxSkipLastTeaser = maxSkipLastTeaser || null;
            query.skip_teaser = "";

            if (maxSkipLastTeaser && !!this.teasersLIst[this.query.sid9] && this.teasersLIst[this.query.sid9].length > 0) {
                let skip = maxSkipLastTeaser;
                if (this.teasersLIst[this.query.sid9].length < skip) {
                    skip = this.teasersLIst[this.query.sid9].length;
                }
                query.skip_teaser = this.teasersLIst[this.query.sid9].slice(skip * -1).join(',');
            }

            var teasers = this.ajaxPull.get(query,
                {
                    onBeforeRequest: (conf) => {


                        if (conf.url.indexOf('&uid=') === -1) conf.url += '&uid=' + this.uid;
                    }
                });

            teasers.onBeforeSuccess((response) => {
                if (!!response.data.log && this.debug.isDebug()) {
                    if (!!!window.config.log) {
                        window.config.log = []
                    }
                    window.config.log.push({
                        offset,
                        log: response.data.log,
                    });
                }

                if (!!response.data.items) {
                    response.data = response.data.items;
                }

                for (var i in response.data) {

                    if (!!response.data[i].fraud) {
                        let fraudImg = document.createElement('img');
                        fraudImg.onload = () => {
                        }
                        fraudImg.src = response.data[i].fraud;
                        fraudImg.width = 1;
                        fraudImg.height = 1;
                        fraudImg.style.opacity = 0;
                        document.body.append(fraudImg);
                    }

                    if (!!!this.teasersLIst[this.query.sid9]) this.teasersLIst[this.query.sid9] = [];
                    this.teasersLIst[this.query.sid9].push(response.data[i].teaser_id);

                    response.data[i].title = response.data[i].title.replace('[CITY]', this.city);
                    response.data[i].description = response.data[i].description.replace('[CITY]', this.city);
                    response.data[i].teaser_id_for_debug =  response.data[i].teaser_id || 0;
                    if (response.data[i].is_rtb === 1) {
                        response.data[i].teaser_id = response.data[i].rtb_imp_id;
                    }

                    if (this.debug.isDebug()) {
                        response.data[i].title = this.debug.teaserInfo(response.data[i]);
                    }
                }
            });

            teasers.onAfterSuccess((response) => {
                setTimeout(() => {
                    console.log("тизеры onAfterSuccess", response.data);
                    this.events.notify('EVENT_LOAD_TEASERS', response.data);
                }, 300);

                // Отправлять запрос если картинки или видео грузятся дольше 0.3 сек
                setTimeout(() => {
                  if (window.teasersMediaLoadingSpeeds) {
                    if (Array.isArray(window.teasersMediaLoadingSpeeds) && window.teasersMediaLoadingSpeeds.length > 0) {
                      const longTeasersImagesLoadingSpeeds = window.teasersMediaLoadingSpeeds.filter((item) => item.time > 0.3);

                      if (longTeasersImagesLoadingSpeeds.length > 0) {   
                        // Запрос
                        let imageLogResponse = this.ajaxPost.post({ uri: '/api/image-log' }, 
                          
                            JSON.stringify(longTeasersImagesLoadingSpeeds), {
                        
                            headers:{'Content-Type': 'application/json'},
                        });
  
                        imageLogResponse.onSuccess((response) => {
                            window.teasersMediaLoadingSpeeds = [];
                        });
                      }
                    }
                  }
                }, 1000);
            });
            return teasers;

    },


    getTeasers2(vue, count, offset, isBoost, isNotClear, appendQuery) {

        //получаем тизеры из сторедж
        let queue = new Queue('teasers');

        let offers = [];
        console.log("count", count);
        console.log("queue.size()", queue.size());
        console.log("window.offsetForTest", window.offsetForTest);

        if (window.offsetForTest ===0 && queue.size() > 0) {
            console.log("queue.getLast",queue.getLast());
            let last = queue.getLast();
            if (last) window.offsetForTest = last.index +1;
        }
        console.log("window.offsetForTest", window.offsetForTest);
        //если есть нужное количество и нет сброса, берем тизры из стореджа
        if (queue.size() >= count) {
            console.log("queue.size() >= count", queue.size() >= count);
            for (let i=1; i<=count; i++) {
                offers.push(queue.dequeue());
            }
           let ajax = new Ajax();
            ajax.onAfterSuccess((response)=> {
                setTimeout(() => {
                    this.events.notify('EVENT_LOAD_TEASERS', response.data);
                }, 300);
            });
            setTimeout(()=>{
                ajax.call('onSuccess', {data:offers})
                ajax.call('onAfterSuccess', {data:offers})
                    }, 100);
            return ajax;
        }
            //запрашиваем 10 - колСтороже
        let countForRequest = 10;
        let query = Object.assign({}, vue.$route.query, appendQuery);

        isBoost     = isBoost || 0;
        isNotClear  = isNotClear || 0;
        query.boost = isBoost;
        // appendQuery = appendQuery || {};

        if(query.type && query.type === "back") {
            query.event = 'back';
        }

        query.dmp = this.getDMPValues(DMPPROF_ID);

        // if (!(vue.$route.name ===  "home" &&  query.type && query.type === "back"))
        //     query.sid9 = vue.$route.name;

        query.sid9 = this.sid9;
        query.uid = this.uid;

        // if (!query.utm_content && window.sessionStorage.getItem('content') !== null) {
        //     query.utm_content = window.sessionStorage.getItem('content');
        // }
        if (!query.utm_content && this.getStorage('content') !== null) {
            query.utm_content = this.getStorage('content');
        }
        console.log("isClear", this.isClear(query));
        console.log("isClearForTest", this.isClearForTest(query));
        if (!isNotClear && this.isClear(query)) {
            query.is_clear = 1;
            //сбрасываем только один раз
            // window.localStorage.setItem("not_clear", "1");
            this._setCookie("not_clear", "1", {expires: new Date(Date.now() + 86400 * 1000)});


            this.notClear = true;
            this.isPreviewRef = false;
        } else if(this.isClearForTest()) {
            // window.sessionStorage.removeItem('isPreviewRefForTest');
            this.setStorage('isPreviewRefForTest', null);
            query.is_clear = 1;
        } else {
            query.is_clear = 0;
        }

        // if (this.isTeaserViewFixAjax) {
        //     query.is_new_view = 1;
        // }

        query.uri    = urlGetAds;
        window.pinter = 0;
        query.count  = countForRequest;
        query.offset = window.offsetForTest;
        query.r = Math.random();

        query.theme = this.theme || "";


        query.resolution_width =  screen.width;
        query.resolution_height = screen.height;
        query.connection_speed = this.connectionSpeed();
        delete query.uid;

        if (query.utm_content) {
            query.article = query.utm_content;
        }
        var teasers = this.ajaxPull.get(query,
            {
                onBeforeRequest: (conf) => {
                    if (conf.url.indexOf('&uid=') === -1) conf.url += '&uid=' + this.uid;
                }
            });

        teasers.onBeforeSuccess((response) => {
            for (var i in  response.data) {
                response.data[i].title = response.data[i].title.replace('[CITY]', this.city);
                response.data[i].description = response.data[i].description.replace('[CITY]', this.city);
                if (response.data[i].is_rtb === 1) {
                    response.data[i].teaser_id = response.data[i].rtb_imp_id;
                }

                if (this.debug.isDebug()) {
                    response.data[i].title = this.debug.teaserInfo(response.data[i]);
                }
                queue.enqueue(response.data[i]);

            }
            window.offsetForTest += response.data.length;
            response.data = [];
            for (let i=1; i<=count; i++) {
                response.data.push(queue.dequeue());
            }

        });

        teasers.onAfterSuccess((response)=> {
            setTimeout(() => {
                this.events.notify('EVENT_LOAD_TEASERS', response.data);
            }, 300);
        });

        return teasers;
    },

    isClear(query) {
        return (this.isPreviewRef || this.getStorage('isPreviewRef') === "1")
            &&  this._getCookie('not_clear') !== "1"
            && (!query.off_view_reset || query.off_view_reset !== "1")
            && (!query.type || query.type !== "back")
    },

    isClearForTest(query) {
        let isPreviewRefForTest = this.getStorage('isPreviewRefForTest');

        return (isPreviewRefForTest == 1 && this.sid9 == 1);
    },

    setStorage(key, value) {
        try {
            window.sessionStorage.setItem(key, value)
        } catch (e) {
            //this._setCookie(key, value);
        }
    },

    getStorage(key) {

        try {
            return  window.sessionStorage.getItem(key)
        } catch (e) {
            return  this._getCookie(key);
        }
    },


    /**
     * установить язык
     * @param язык, например 'ru'
     */
    setLanguage(lang, languageDefault) {


        //if (this.debug.isDebug()) {
            let query = this.getQuery();
            if (query.language) {
                lang = query.language;
            }
        //}
        languageDefault = languageDefault.toLowerCase();
        lang = lang.toLowerCase();

        try {
            this.translate = require(`./language/${lang}`).default;
            this.language = lang;
             this.query.language = lang;
            return true;
        } catch (e) {
            this.translate = require(`./language/${languageDefault}`).default;
            this.language = this.languageDefault;
             this.query.language = this.language;
            console.warn(`Языковый файл не найден, подключен язык по умолчанию (${this.languageDefault})`)
            return false;
        }
    },

    getBrowserLanguage() {
        let client = window.navigator ? (window.navigator.language ||
            window.navigator.systemLanguage ||
            window.navigator.userLanguage) : (config.language.toLowerCase() + "-" + config.country.toUpperCase());

        // let language = (client.search('-') > 0) ?
        //     client.substring(0, client.search('-')).toLowerCase() :
        //     client.toLowerCase();

        return client;
    },

    /**
     * перевод слов
     * @param key
     * @returns {*}
     */
    t(key, def) {
        if (!this.translate[key])  return def || key;
        return this.translate[key];
    },

    /**
     * клик по новостному тизеру
     * @param vue
     * @param news
     */
    newsClick(vue, news, route, isBlank, params) {

        route = route || 'view';
        isBlank = isBlank || false;
        params = params || {};

        this.events.notify('EVENT_NEWS_VIEW_CLICK', {vue, news, route, params});

        let query = vue.$route.query;
        query.utm_content = news.hash_id;
        this.query.utm_content = news.hash_id;
        query.rnd = Math.random();
        this.query.rnd =  Math.random();
        delete query.type;

        //открывать в новой вкладке?
        if (isBlank) {
            let routeData = vue.$router.resolve({name: route, query, params});
            window.open(routeData.href, '_blank');
            return;
        }


        vue.$router.replace({name : route,  query, meta:{previewform:true}, params});
        window.scrollTo(0,0);


    },

    getNewsUrl(vue, news, route) {

        route = route || 'view';

        let query = Object.assign({}, vue.$route.query);
        query.utm_content = news.hash_id;
        delete query.type;
        let path = '';

        for (let i in vue.$router.options.routes) {
            if (vue.$router.options.routes[i].name === route) {
                path = vue.$router.options.routes[i].path;
                break;
            }
        }

        if (path === '') return '#';


        uri = '';
        for (let i in query) {
            uri += '&' + i + '=' + query[i];
        }

        if (uri !== '') {
            return path + '?' + uri.substr(1, uri.length);
        }

        return path;
    },


    getNewsUrl(vue, news, route) {

        route = route || 'view';

        let query = Object.assign({}, vue.$route.query);
        query.utm_content = news.hash_id;
        delete query.type;
        let path = '';

        for (let i in vue.$router.options.routes) {
            if (vue.$router.options.routes[i].name === route) {
                path = vue.$router.options.routes[i].path;
                break;
            }
        }

        if (path === '') return '#';


        uri = '';
        for (let i in query) {
            uri += '&' + i + '=' + query[i];
        }

        if (uri !== '') {
            return path + '?' + uri.substr(1, uri.length);
        }

        return path;
    },

    /**
     * Переопределить шаблон на вью
     * @param templateShowId
     */
    setTemplateShowPreviewButton(templateShowId) {
        this.templateShowIdForView = templateShowId;
    },

    /**
     * Клик по кнопке "читать далее" в привью новости
     * @param vue
     * @param news
     */

    previeClick(vue, news, route, isBlank) {


        isBlank = isBlank || false;

        if (this.isInIframe()) {
            isBlank = true;
        }

        this.isPreviewRef = true;
        //window.sessionStorage.setItem('isPreviewRef', 1);
        this.setStorage('isPreviewRef', 1);

        //Для теста
        // if (this.query.test == 1) window.sessionStorage.setItem('isPreviewRefForTest', 1);
        if (this.query.test == 1) this.setStorage('isPreviewRefForTest', 1);


        let query = vue.$route.query;

        delete query.type;
        if (query.sid9 && query.sid9 === "preview") delete query.sid9;
        // query.sid9 = this.sid9;

        // if (!query.utm_content && news.hash_id)  {
        //     query.utm_content = news.hash_id;
        // }

        query.rnd = Math.random();
        //если задан шаблона выдачи для вью
        if (this.templateShowIdForView) {
            query.templates_show_id = this.templateShowIdForView;
        }

        //открывать в новой вкладке?
        if (vue.Config.is_redirect_read_more !== 0 || isBlank) {

            let routeData = vue.$router.resolve({name: route, query});
            window.open(routeData.href, '_blank');

            //что нужно открыть в текущей вкладке
            if (vue.Config.redirect_read_more !== '') {
                location.href = vue.Config.redirect_read_more;
            }
            return;
        //wap редирект
        } else if (this.isWap && this.wapRedirect !== '') {
            function setCookieWithExpireTime(cookieName, expireTimeInSeconds) {
                let d = new Date();
                d.setTime(d.getTime() + (expireTimeInSeconds * 1000));
                let expires = "expires="+d.toUTCString();
                document.cookie = cookieName + "=" + "wapRedirectTime" + ";" + expires + ";path=/";
            }

            function checkCookie(cookieName) {
              let name = cookieName + "=";
              let decodedCookie = decodeURIComponent(document.cookie);
              let cookieArray = decodedCookie.split(';');
              for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                  while (cookie.charAt(0) == ' ') {
                      cookie = cookie.substring(1);
                  }
                  if (cookie.indexOf(name) == 0) {
                      return true; // Возвращаем true, если переменная cookie присутствует
                  }
              }
              return false; // Возвращаем false, если переменная cookie отсутствует
            }

            let isWapRedirectTimePresent = checkCookie('wapRedirectTime');

            if (isWapRedirectTimePresent) {
                console.log('Переменная wapRedirectTime найдена в cookie.');
            } else {
                console.log('Переменная wapRedirectTime не найдена в cookie.');

                setCookieWithExpireTime('wapRedirectTime', 24 * 60 * 60); // 24ч

                window.open(this.wapRedirect, '_blank').focus();
            }
        }
        // this.newsClick(vue, news, route);

        vue.$router.push({name : route,  query});
        window.scrollTo(0,0);
    },
    newsPreviewClick(vue, news, route, isBlank) {
        route = route || 'view';
        this.events.notify('EVENT_NEWS_PREVIEW_CLICK', {vue, news, route});

        let nextFunc = () => {

            if (this.beforeEventPreviewToView.length === 0) {
                this.previeClick(vue, news, route, isBlank);
                return
            }
            let func = this.beforeEventPreviewToView.shift();
            let result = func();

            if (typeof result === "object" && result.event) {
                switch (result.event) {
                    case 'sleep':
                        setTimeout(nextFunc, result.time);
                        return
                }
            }
            nextFunc();
        };
        setTimeout(nextFunc, 100);

        // beforeEventPreviewToView.push(function () {
        //
        //     return {event:'sleep', time: 500}
        // })

    },


    reloadNews(routeName, content) {
        if (!vueApp) return;
        let query =  Object.assign({}, vueApp.$route.query);
        query.utm_content = content;
        query.rnd = Math.random();
        query.reload = 1;
        // window.sessionStorage.removeItem('isPreviewRef');
        // setTimeout( () => {
        window.vueApp.$router.push({name: routeName, query: query});//.catch(() => {});
        // },500);
    },

    nextNews(content, routeName = 'preview') {
        fetch(this.host + urlNextNews +'?hash=' + content, {
            method: "GET"
        })  .then(response => response.json())
            .then(data => {

                if (data.hash_id) {
                    this.reloadNews(routeName, data.hash_id)
                }
            });

    },
    /**
     * получить один тизер
     * @param teasers - массив тизеров
     */

    getOneTeaser(teasers) {
        let out = teasers[window.pinter];
        if (!out) return [];

        window.pinter++;
        if (window.pinter >= teasers.length) {
            window.pinter = 0;
        }

        return out;
    },

    /**
     * получить несколько тизеров
     * @param teasers - массив тизеров
     * @param amount - количество
     */

    getManyTeaser(teasers, amount) {
        let out = [];
        for (let i = 0; i< amount; i++) {
            out.push(this.getOneTeaser(teasers));
        }
        return out;
    },
    setBackSid9(){
        let backCount = 0;

        if (!isNaN(Number(this.getStorage('backCount2')))) {
            backCount = Number(this.getStorage('backCount2'));
        }

        backCount++;
        this.sid9 = backCount;
        this.query.sid9= this.sid9;

        this.setStorage('backCount2', backCount);
        this.setStorage('backCount', backCount);
    },
    getBackSid9(){
        let backCount = 0;

        if (!isNaN(Number(this.getStorage('backCount2')))) {
            backCount = Number(this.getStorage('backCount2'));
        }

        return backCount;
    },
    routerAfterEach(to, from) {

        console.log('routerAfterEach');
        console.log('to', to);
        console.log('from', from);

        if (to.query.type === "back" && (to.name === "home" || to.name === "back") ) {
            this.isToBack = true;
            let backCount = 0;

            // if (sessionStorage.getItem('backCount2') !== null) {
            //     backCount = Number(sessionStorage.getItem('backCount2'));
            // }

            if (!isNaN(Number(this.getStorage('backCount2')))) {
                backCount = Number(this.getStorage('backCount2'));
            }

            backCount++;
            this.sid9 = backCount;
            console.log('sid9', this.sid9);

            // this.setSid9(backCount);

            // sessionStorage.setItem('backCount2', backCount);
            this.setStorage('backCount2', backCount);
            this.setStorage('backCount', backCount);


            this.events.notify('EVENT_BACK', to);
        } else {
            this.sid9 = to.name;
            // this.setSid9(to.name);
        }

        to.query.sid9= this.sid9;
        this.query.sid9= this.sid9;

        setTimeout(()=> {
            this.getPixel(this.query);
        }, 100);

        this.addOrReplaceUrlParam(to.query, 'sid9', this.sid9 );
        this.addOrReplaceUrlParam(to.query, 'uid', this.uid );
        this.removeUrlParam(to.query, 'is_visitor');

        window.scrollTo(0,0);

        console.log("to EVENT_LOAD_PAGE",  to);
        this.events.notify('EVENT_LOAD_PAGE', to);

        console.log("next to EVENT_LOAD_PAGE",  to);
        this.nextCout = 0;

    },
    routerBeforeEach(to, from, next)
    {

        console.log('routerBeforeEach');
        console.log('to', to);
        console.log('from', from);

        //window.isback - в скирпте кнопки назад
        // if (window.isback && (this.isPreviewToView(to.name, from.name)
        //     || this.nextCout > 1
        //     || this.isHomeToView(to.name, from.name))) {
        //     console.log('next(false)', true);
        //     next(false);
        //     return ''
        // }
        console.log(
            "window.isback",
            !!!to.query.reload,
            window.isback,
            (to.query.rnd && this.nextRnd.indexOf(Number(to.query.rnd)) !== -1) || this.isPreviewPreview(to.name, from.name)
        );

        if (!!!to.query.reload && window.isback
            && ((to.query.rnd && this.nextRnd.indexOf(Number(to.query.rnd)) !== -1) || this.isPreviewPreview(to.name, from.name))) {
                console.log('next(false)', true);
                next(false);
                return ''
        }

        this.nextCout++;
        if (to.query.rnd) {
            this.nextRnd.push(Number(to.query.rnd));
        }

        this.isLoadDmp = false;


        let callback  = () => {
            console.log("qqqqq calback");
            // if (this.isLoadDmp) {
            //     return;
            // }
            // this.isLoadDmp = true;
            if (to.query.is_visitor && to.query.is_visitor == 1) {
                this.is_visitor = 1;
                delete to.query.is_visitor;
                if (!!this.query.is_visitor) delete this.query.is_visitor;
            } else {
                this.is_visitor = 0;
            }
            console.log("to.query", to.query);
            next({query: to.query});
            return;

        };

        if (!!window.uid) {
            console.log("window.uid", window.uid);
            this.uid = window.uid;
            console.log(this.uid, this.uid);
            callback();

            return
        }

        // console.log("timeoutLoadDmp", this.timeoutLoadDmp);
        if (!this.isDmp) {
            this._setCustomUid();
            window.uid = this.uid;
            this.addOrReplaceUrlParam(this.query, 'uid', this.uid);
            callback();
            return;
        }
        let countdown = this.timeoutLoadDmp;
        let timer = setInterval(() => {
            countdown-=30;
            //console.log("timeoutLoadDmp", countdown);
            //если прошло время и dmp не подгрузился, генерируем свой
            if (!!!window.uid && countdown <= 0) {
                clearInterval(timer);
                this._setCustomUid();
                window.uid = this.uid;
                this.addOrReplaceUrlParam(this.query, 'uid', this.uid);
                callback();
                return;
            }
            //если время не прошло ждем дальше
            if (!!!window.uid) {
                return;
            } else {
                //dmp получен
                console.log("dmp получен");
                clearInterval(timer);
                this.uid = window.uid;
                this.addOrReplaceUrlParam(this.query, 'uid', this.uid);
                callback();
                return;
            }

        }, 30);


    },
    isPreviewToView(to_name, from_name)
    {
        return  to_name === "preview" && from_name=== "view";
    },

    isPreviewPreview(to_name, from_name)
    {
        return  to_name === "preview" && from_name=== "preview";
    },

    isHomeToView(to_name, from_name)
    {
        return  to_name === "view" && from_name=== "home";
    },


    getClickUrl(teaser)
    {
        if (!teaser.click) {
            return "#";
        }

        let url = teaser.click;
        let query = this.query;

        for (let i in query) {
            if (i.indexOf('sid') > -1 || i.indexOf('SID') > -1 || i.indexOf('exp') > -1) {
                if ((i.indexOf('sid') > -1 || i.indexOf('SID') > -1)
                    && (/^sid[0-4]$/.test(i) || /^SID[0-4]$/.test(i)) ) continue;
                url += '&'+ i +'=' + query[i];
            }
        }

        url += '&resolution_width=' + screen.width;
        url += '&resolution_height=' + screen.height;
        url += '&connection_speed=' + this.connectionSpeed();
        url += '&position=' + teaser.position;
        if (!query.templates_show_id || query.templates_show_id != 41) {
            if (!query.utm_content && this.getStorage('content') !== null) {
                url += '&utm_content=' + this.getStorage('content');
            } else if (!!this.query.utm_content) {
                url += '&utm_content=' + this.query.utm_content;
            } else {
                url += '&utm_content=';
            }
        }

        return url;
    },

    /**
     * Клик по тизеру
     * @param vue
     * @param  teaser
     */
    adClick(vue, teaser, isBlank) {

        if (!teaser.click) {
            return;
        }

        isBlank = isBlank || false;

        // if (!(vue.$route.name ===  "home" &&  query.type && query.type === "back"))
        //     vue.$route.query.sid9 = vue.$route.name;

        let query = this.query;

        // vue.$route.query.sid9 = query.sid9 = this.sid9;



        // // if (vue.$route.query.sid9) teaser.click += '&sid9=' + vue.$route.query.sid9;
        // for (let i in query) {
        //     if (i.indexOf('sid') > -1 || i.indexOf('SID') > -1 || i.indexOf('exp') > -1) {
        //         if ((i.indexOf('sid') > -1 || i.indexOf('SID') > -1) && (/^sid[0-4]$/.test(i) || /^SID[0-4]$/.test(i)) ) continue;
        //         teaser.click += '&'+ i +'=' + query[i];
        //     }
        // }
        //
        // teaser.click += '&resolution_width=' + screen.width;
        // teaser.click += '&resolution_height=' + screen.height;
        // teaser.click += '&connection_speed=' + this.connectionSpeed();

        let url = this.getClickUrl(teaser);


        this.events.notify('EVENT_TEASER_CLICK', {vue, teaser});


        //открывать в новой вкладке?
        if (vue.Config.is_redirect_from_ad !== 0 || isBlank) {
            window.open(url, '_blank', 'noopener');

            //что нужно открыть в текущей вкладке
            if (vue.Config.redirect_from_ad !== '') {
                location.href = vue.Config.redirect_from_ad;
            }
            return;
        }
        //если во фрейме открываем в родительском окне
        // if (window.top) {
        //     window.top.location.href = teaser.click;
        //     return;
        // }

        location.href = url;
    },


    getPixel(query)
    {



        let domain = this.getPixelDomain();
        let path = this.getPixelPath(this.pixelUrl);

        let url = '//' + domain  + path + this._getPixelUri(query);

        let pixel;
        if (!document.getElementById("pixelss")) {
            pixel = document.createElement('img');
            pixel.id = "pixelss";
            pixel.src = url;
            document.body.append(pixel);

        } else {
            let pixel = document.getElementById("pixelss");
            pixel.src = url;
        }


    },


    getPixelDomain()
    {
        let domain;
        //если домен есть в url
        if (this.query.d) {
            domain = this.query.d;
            this.setStorage('pixel_domain', domain);
        } else if (this.getStorage('pixel_domain') !== null) {
            domain = this.getStorage('pixel_domain');
        } else {
            domain = this.getDomainFromUrl(this.pixelUrl);
        }

        return domain;
    },

    getPixelPath(url) {
        if (url.indexOf('//') === 0) {
            url = 'https:' + url
        }
        const urlObj = new URL(url);
        return urlObj.pathname;
    },

    getDomainFromUrl(url) {
        if (url.indexOf('//') === 0) {
            url = 'https:' + url
        }
        const urlObj = new URL(url);
        return urlObj.host;
    },

    _getPixelUri(query)
    {

        let obj = this._getPixelUriObject(query);
        if (this.is_send_visitor && !!obj.is_visitor) {
            obj.is_visitor = 0;
            delete obj.is_visitor;
        }
        let uri = '?';

        for (let key in obj) {
            if (uri !== "?") {
                uri += "&";
            }
            uri += key + "=" + obj[key];
        }

        return uri;
    },


    _getPixelUriObject(query)
    {
        // console.log("pixel query", query);
        query = Object.assign({}, query);

        let uri = {};

        // console.log('query', vue.$route);
        //
        // if (!query.utm_content && window.sessionStorage.getItem('content') !== null) {
        //     query.utm_content = window.sessionStorage.getItem('content');
        // }
        if (!query.utm_content && this.getStorage('content') !== null) {
            query.utm_content = this.getStorage('content');
        }
        uri.sid9  = this.sid9;

        let params = [
            {param:'utm_campaign',  'queryName': 'utm_campaign', default: 0},
            {param:'utm_content', 'queryName': 'utm_content',    default: ''},
            {param:'utm_source',    'queryName': 'utm_source',   default: ''},
            {param:'utm_medium',    'queryName': 'utm_medium',   default: ''},
            // {param:'SID10',   'queryName': 'SID10',           default: ''},
            {param:'subid3',   'queryName': 'subid3',           default: ''},
            {param:'subid4',   'queryName': 'subid4',           default: ''},
            {param:'subid5',   'queryName': 'subid5',           default: ''},
            {param:'client_id',   'queryName': 'uid',            default: ''},
            {param:'bind-key',   'queryName': 'bind-key',        default: null},
            {param:'cost',   'queryName': 'cost',        default: 0},
            {param:'ip',   'queryName': 'ip',        default: ''},
            {param:'DEBUG',   'queryName': 'DEBUG',        default: ''},
            {param:'isd',   'queryName': 'isd',        default: ''},
            // {param:'dmp_uid',   'queryName': 'dmp_uid',       default: ''},
        ];




        for (let i in params) {
            if (!query[params[i].queryName] && params[i].default === null) continue;
            uri[params[i].param] = (query[params[i].queryName])  ? query[params[i].queryName] : params[i].default;
        }


        for (let i in query) {
            if (i.indexOf('sid') > -1 || i.indexOf('SID') > -1 || i.indexOf('exp') > -1 ) {
                //if ((i.indexOf('sid') > -1 || i.indexOf('SID') > -1) && (/^sid[0-4]$/.test(i) || /^SID[0-4]$/.test(i)) ) continue;
                uri[i] = query[i];
            }
        }

        if (this.project === PROJECT_GOOGLE_NEWS) {
            uri.SID10= (query.utm_term) ? query.utm_term : query.SID10;
        }

        uri.category = 0;
        //uri.resolution_width = screen.width;
        //uri.resolution_height = screen.height;
        //uri.connection_speed = this.connectionSpeed();
        uri.domain = location.host;
        uri.t = config.theme;

        if (this.is_visitor) {
            uri.is_visitor = 1
        }

        return uri;
    },

    //устаревшая функция,
    getPixelUrl(vue)
    {
        //заглушка
        return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+P+/HgAFhAJ/wlseKgAAAABJRU5ErkJggg==';

        // let query = Object.assign({}, vue.$route.query);
        //
        // return this._getPixelUrl(query);
    },
    connectionSpeed(){
        let connection = navigator.connection
            || navigator.mozConnection
            || navigator.webkitConnection
            || {
                downlink:null,
                effectiveType:null,
            };

        let connect = connection.effectiveType  || "" ;

        if (connection.downlink) {
            connect += "," + connection.downlink;
        }

        return connect;
    },
    connectionSpeedObj(){
        let connection = navigator.connection
            || navigator.mozConnection
            || navigator.webkitConnection
            || {
                downlink:null,
                effectiveType:null,
            };

        let type = connection.effectiveType  || "" ;
        let speed = connection.downlink || '';

        return {type, speed};
    },


    isInIframe () {
        try {
            return window != window.top || document != top.document || self.location != top.location;
        } catch (e) {
            return true;
        }
    },

    getIndex()
    {
        if (isNaN(window.indexTeaser)) window.indexTeaser = 0;
        return window.indexTeaser++;

    },


    isReadNews() {
        if (!document.getElementById(this.newsElementId)) return false;

        let param = document.getElementById(this.newsElementId).getBoundingClientRect();

        return window.outerHeight - param.top < param.height + window.outerHeight && window.outerHeight - param.top > 0;

    },

    getPercentReadNews()
    {
        if (!document.getElementById(this.newsElementId)) return -1;

        let param = document.getElementById(this.newsElementId).getBoundingClientRect();

        let percent = (window.outerHeight - param.top)/param.height *100;
        return (percent > 100) ? 100 : percent;
    },


    setSid9(value)
    {
        this.sid9 = value;
        this.addOrReplaceUrlParam('sid9', value)
    },


    addOrReplaceUrlParam(query, prmName, val)
    {
        query[prmName] = val;

        let d = location.href.split("#")[0].split("?");
        let base = d[0];
        let res = '';
        for (let i in query) {
            if (i === "") continue;
            res += i + '=' + (query[i] || '') + "&";
        }
        res = res.replace(/\&$/, "");
        window.history.replaceState(null, null, base + '?' + res);

        if (window.vueApp && window.vueApp.$route.query) {
            window.vueApp.$route.query[prmName] = val;
            this.query[prmName] = val;
        }

        return false;
    },

    removeUrlParam(query, prmName)
    {
        let d = location.href.split("#")[0].split("?");
        // console.log(d);
        let base = d[0];
        let res = '';
        for (let i in query) {
            if (i === "" || i === prmName) continue;
            res += i + '=' + (query[i] || '') + "&";
        }
        res = res.replace(/\&$/, "");
        window.history.replaceState(null, null, base + '?' + res);

        if (window.vueApp && window.vueApp.$route.query) {
            delete window.vueApp.$route.query[prmName];
            delete this.query[prmName];
        }

        return false;
    },

    // _setUID(callback) {
    //
    //     if (!this.isDmp || !this.dmpScript) {
    //         this._setCustomUid();
    //
    //         if (callback) callback();
    //
    //         return;
    //     }
    //
    //     let dmpPixelUrl = this.dmpScript;
    //     this._injectScript(dmpPixelUrl)
    //         .then(() => {
    //
    //             console.log(dmpPixelUrl + 'load');
    //             if (typeof window.dmpProfitclicks === "undefined" || typeof window.dmpProfitclicks.match !== "function") {
    //                 this._setCustomUid();
    //                 this.goals.reachGoalError("window.dmpProfitclicks undefined or window.dmpProfitclicks.match != function");
    //             }
    //
    //             if (this.uid) {
    //                 if (callback) callback();
    //                 return;
    //             }
    //
    //             window.dmpProfitclicks.match('view', 0, (uid) => {
    //                 this.audiences = {};
    //                 let isSetCookie = false;
    //                 // this.query.uid = uid || '';
    //                 // this.uid = uid || '';
    //                 // console.log("get uid profile", this.uid);
    //
    //                 console.log("this.query.uid", this.query.uid);
    //                 console.log("uid match", uid);
    //                 let cookieUid =  this._getCookie("duid", null);
    //
    //                 // if (this.query.client_id) {
    //                 //     this.uid = this.query.client_id;
    //                 //     console.log("get uid client_id", this.uid);
    //                 // } else
    //
    //                     if (cookieUid) {
    //                     this.uid =cookieUid;
    //                     console.log("get uid cookie", this.uid);
    //                 // }
    //
    //                     // else if (this.query.uid) {
    //                     // this.uid = this.query.uid;
    //                     // console.log("get uid query.uid", this.uid);
    //                 }else{
    //                     isSetCookie = true;
    //                     this.query.uid = uid || '';
    //                     this.uid = uid || '';
    //                    console.log("get uid profile", this.uid);
    //                 }
    //
    //
    //
    //                 // //если есть в url, берем от туда
    //                 // if (this.query.dmp) {
    //                 //     let dmp = this.query.dmp.split(',');
    //                 //     audiences = {};
    //                 //     for (let i in dmp) {
    //                 //         audiences[dmp[i]] = 1;
    //                 //     }
    //                 //
    //                 //     this.audiences = audiences;
    //                 // }
    //
    //                 if (!this.uid) {
    //                     this._setCustomUid();
    //                     this.goals.reachGoalError("empty uid " + dmpPixelUrl);
    //                 }
    //
    //                 // this.goals.setUid(this.uid);
    //                 this.addOrReplaceUrlParam(this.query, 'uid', this.uid);
    //                 if (isSetCookie) {
    //                     this._setCookie("duid", this.uid, {expires: new Date(Date.now() + 86400 * 1000)});
    //                     this.setStorage("uid", this.uid);
    //                 }
    //
    //
    //                 if (callback) callback();
    //             }, (error) => {
    //                 this._setCustomUid();
    //                 this.goals.reachGoalError("Error get uid (getProfile): " + error);
    //                 if (callback) callback();
    //             });
    //         }).catch(error => {
    //         this._setCustomUid();
    //         this.goals.reachGoalError("Error get uid (load script): " + error);
    //         if (callback) callback();
    //     });
    //
    // },

    _setCustomUid()
    {
        let cookieUid = this._getCookie('duid', undefined);

        if (cookieUid) {
            this.uid =cookieUid;
            console.log("get uid cookie", this.uid);
        } else if (this.query.client_id) {
            this.uid = this.query.client_id;
            console.log("get uid client_id", this.uid);

        }  else if (this.query.uid) {
            this.uid = this.query.uid;
            console.log("get uid query.uid", this.uid);
        }  else if (this.getStorage("uid") != null) {
            this.uid = this.getStorage("uid");
            console.log("get uid getStorage", this.uid);
        }
        else {
            this.uid = this._generateUUID();
            console.log("get uid _generateUUID", this.uid, cookieUid);
            // Вызов функции checkUid из шаблона для добавления скрипта kaminari
            // window.checkUid();
            // console.log('window.checkUid');
            
            this._setCookie("duid", this.uid, {expires: new Date(Date.now() + 86400 * 1000)});
            this.setStorage("uid", this.uid);
        }

        this.addOrReplaceUrlParam(this.query, 'uid', this.uid);
    },

    old___setUID(callback) {

        if (this.query.uid && this.query.uid != 'null') {
            this.uid = this.query.uid;
            if (callback) callback();
            return;
        }

        let query = {};
        query.uri = this.pixelDomain + urlGetUid;

        let uidResponse =  this.ajaxPull.get(query,{
            // baseURL:this.pixelDomain,
            headers:{
                'Content-Type': 'application/json'
            }
        });
        uidResponse.onSuccess((response)=>{

            this.uid = response.data.uid || '';
            this.query.uid = response.data.uid || '';
            if (!this.uid) {
                this.goals.reachGoalError("empty uid");
            }
            // this.goals.setUid(this.uid);
            this.addOrReplaceUrlParam(this.query, 'uid', this.uid);
        });
        uidResponse.onFail(error => {
            console.log("get uid error", error);
            this.goals.reachGoalError("Error get uid: " + error.message);
        });

        uidResponse.onFinal(error => {
            if (callback) callback();
        });
    },


    getQuery() {
        var url = location.search;
        var qs = url.substring(url.indexOf('?') + 1).split('&');
        for(var i = 0, result = {}; i < qs.length; i++){
            qs[i] = qs[i].split('=');
            try {
                result[qs[i][0]] = (qs[i][1] !== null)  ?
                    decodeURIComponent(qs[i][1]) : '';
            } catch (e) {
                result[qs[i][0]] = qs[i][1];
            }
        }
        return result;
    },

    _setCookie(name, value, options = {}) {

        options = Object.assign( {
            path: '/',
            // при необходимости добавьте другие значения по умолчанию

        }, options);

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    },

    _getCookie(name, valDefault) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : (valDefault || undefined);
    },

    _injectScript(src) {
        return new Promise((resolve, reject) => {
            let script = document.head.querySelectorAll(`script[src='${src}']`);

            if (script.length > 0) {
                resolve();
                return;
            }

            script = document.createElement('script');
            script.async = true;
            script.src = src;
            script.addEventListener('load', resolve);
            script.addEventListener('error', () => reject('Error loading script.'));
            script.addEventListener('abort', () => reject('Script loading aborted.'));
            document.head.appendChild(script);
        });
    },

    _getDmp(callback) {
        let dmpPixelUrl = '//pwrlkyotm.com/pixels/pixel_4.js';
        this._injectScript(dmpPixelUrl)
            .then(() => {
                if (typeof window.dmpProfitclicks === "undefined" || typeof window.dmpProfitclicks.getProfile !== "function") {
                    throw new Error('Error _getDmp (_injectScript): window.dmpProfitclicks undefined or window.dmpProfitclicks.getProfile != function');
                }

                window.dmpProfitclicks.getProfile((profile) => {
                    this.audiences = profile.audiences || {};
                    this.dmp_created_at = profile.created_at || null;
                    if (callback) callback();
                }, (error) => {
                    this.goals.reachGoalError("Error _getDmp (getProfile): " + error);
                    if (callback) callback();
                });
            }).catch(error => {
            this.goals.reachGoalError("Error _getDmp (_injectScript): " + error);
            if (callback) callback();
        });

    },

    getDMPValues(dmpId) {
        let out = [];
        let audiences = this.audiences;



        for (let id in audiences) {
            let result = null;

            for (let i in this.dmpAttributeTaxonomy[dmpId]) {
                if (this.dmpAttributeTaxonomy[dmpId][i].id_property == id) {
                    result = this.dmpAttributeTaxonomy[dmpId][i].dmp_config_id;
                    break;
                }
            }

            if (result) {
                out.push(result);
            }

        }


        return out.join(',');
    },

    _generateUUID() {
        var d = new Date().getTime();//Timestamp
        var d2 = (performance && performance.now && (performance.now()*1000)) || 0;
        return 'news-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16;
            if(d > 0){
                r = (d + r)%16 | 0;
                d = Math.floor(d/16);
            } else {
                r = (d2 + r)%16 | 0;
                d2 = Math.floor(d2/16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    },

    _fail(name, excep) {
        if (!!!window.config.log) window.config.log = [];

        window.config.log.push({
            'function': name,
            log: excep,
        });


        let ajax = new Ajax({});
        setTimeout(() => {
            ajax.call('onFail', {})
        }, 50);

        return ajax;
    }



}
